module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Diepflingen-4f95f32282d380fe9503a414f4ae835e.svg";